// ✅ US Market FAQ - Thin Wrapper (DRY principle)
import FAQPage from '../../sub/faq';
import SEOHead from '../../../components/SEOHead';

export default function USFAQ() {
  return (
    <>
      <SEOHead
        title='FAQ | Frequently Asked Questions | LBVisible'
        description='Answers to common questions about our web development, SEO, and digital marketing services.'
        keywords='FAQ USA, web development questions, SEO questions'
        canonicalUrl='/us/sub/faq'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/sub/faq' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/sub/faq' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/sub/duk' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/sub/faq' },
        ]}
      />

      <FAQPage />
    </>
  );
}
